import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';

interface ClientLinkProps {
  clientName: string;
  className?: string;
}

export default function ClientLink({ clientName, className = '' }: ClientLinkProps) {
  const handleClientClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    
    // Encode the client name for URL
    const encodedClientName = encodeURIComponent(clientName);
    const url = `/deals/client/${encodedClientName}`;
    
    // Open in new window
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      onClick={handleClientClick}
      className={`inline-flex items-center space-x-1 text-emerald-600 dark:text-emerald-400 hover:text-emerald-700 dark:hover:text-emerald-300 transition-colors ${className}`}
      title={`View all deals for ${clientName}`}
    >
      <ArrowTopRightOnSquareIcon className="w-4 h-4" />
    </button>
  );
} 